import { render } from "./Photo.vue?vue&type=template&id=dbaf8316"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__